import { createClient } from '@supabase/supabase-js'

// Replace these with your actual Supabase values
const supabaseUrl = 'https://sozjaxvcnfzsstjtgauf.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNvempheHZjbmZ6c3N0anRnYXVmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTE3ODU0MDIsImV4cCI6MjA2NzM2MTQwMn0.B-8SHMv_YUV1mROwlGHJm34npPBe40WoeQ0hJv9CV5w'

export const supabase = createClient(supabaseUrl, supabaseKey)
